export const SET_ANALYTIC_PAGE_VIEW_READY = 'SET_ANALYTIC_PAGE_VIEW_READY';
